import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ContractorService } from 'src/app/Service/Contractor/Contractor.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { MoneyService } from 'src/app/Service/Money/Money.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DeviceBehfaRepairForm',
  templateUrl: './DeviceBehfaRepairForm.component.html',
  styleUrls: ['./DeviceBehfaRepairForm.component.scss']
})
export class DeviceBehfaRepairFormComponent implements OnInit {

  Token: string = ""
  UserDsc: string = ""
  UserDscFirst: string = ""
  UserDscSecond: string = ""

  UserDateTimeFirst: string = ""
  UserDateTimeSecond: string = ""
  UserDateTimeThird: string = ""

  UserUserNameFirst: string = ""
  UserUserNameSecond: string = ""
  UserUserNameThird: string = ""


  third_dsc: string = ""
  third_phone: string = ""
  third_price: string = ""
  third_price2: number = 0
  third_device_id: string = "0"


  InProccessing: boolean = false
  canEditMainForm: boolean = true
  canAnswerFirst: boolean = false
  canAnswerSecond: boolean = false
  canAnswerThird: boolean = false

  first_Answer:boolean=null
  second_answer:boolean=null

  page:number=0

  @Input() inner_DeviceBehfa: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()
  @Output() OnBack_DeviceBehfaRepairForm = new EventEmitter<number>();

  constructor(
    private Alertify_Service: AlertifyService,
    private DeviceBehfa_Service: DeviceBehfaService,
    private modalService: BsModalService,
    private Money_Service: MoneyService,
    private Contractor_Service: ContractorService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');



    if (this.inner_DeviceBehfa.id > 0) {
      this.OnInitial()
    }else{
      this.ReadData_Contractor()
    }

  }


  //#region  Device Behfa

  modalRef_DeviceBehfa: any;

  Procssing_DeviceBehfa: boolean = false

  Search_Code_DeviceBehfa_Table: string = ''

  openModal_DeviceBehfa(template: TemplateRef<any>) {
    this.modalRef_DeviceBehfa = this.modalService.show(template);
  }

  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []
  Data_Seleted_DeviceBehfa_Record: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()

  ReadData_DeviceBehfa_KeySearch_Timer: any
  ReadData_DeviceBehfa_KeySearch() {

    if (this.ReadData_DeviceBehfa_KeySearch_Timer) {
      clearTimeout(this.ReadData_DeviceBehfa_KeySearch_Timer);
      this.ReadData_DeviceBehfa_KeySearch_Timer = null;
    }

    this.ReadData_DeviceBehfa_KeySearch_Timer = setTimeout(function () {
      this.ReadData_DeviceBehfa()
    }.bind(this), 1000);

  }

  ReadData_DeviceBehfa() {


    if (!this.Search_Code_DeviceBehfa_Table) {
      this.DataList_DeviceBehfa = []
    }
    else {
      this.Procssing_DeviceBehfa = true

      this.DeviceBehfa_Service.GetSearchBehfaDeviceUnRepair(this.Token, this.Search_Code_DeviceBehfa_Table).subscribe(
        data => {

          this.DataList_DeviceBehfa = data
          this.Procssing_DeviceBehfa = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.Data_Seleted_DeviceBehfa_Record = item
    this.modalRef_DeviceBehfa.hide()
  }

  //#endregion


  //#region Money
  Selected_Money: General_Interface = Empty_General_Interface()
  DataList_Money: Array<General_Interface> = []
  Read_Money() {
    this.Money_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_Money = data
        this.Read_FirstUser()
      }
    )
  }

  //#endregion


  //#region Image
  BaseUrl = environment.BaseUrl
  UploadImageSrc_List: Array<string> = []
  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.DeviceBehfa_Service.uploadFileRepair(formData, this.Token).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc = ''
    this.Alertify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }

  modalRef_Image: any;
  ModalimageUrl: string = ''
  openModal(template: TemplateRef<any>, imageUrl: string) {
    this.ModalimageUrl = imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }

  //#endregion


  //#region Contractor

  Selected_Contractor: General_Interface = Empty_General_Interface()
  DataList_Contractor: Array<General_Interface> = []
  ReadData_Contractor() {
    this.Contractor_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.DataList_Contractor = data
        this.Read_Money()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Selected_Contractor_Customer: General_Interface = Empty_General_Interface()
  DataList_Contractor_Customer: Array<General_Interface> = []
  ReadData_Contractor_Cusetomer() {
    this.Selected_Contractor_Customer.id=0
    this.Contractor_Service.GetCustomerActiveList(this.Token,this.Selected_Contractor.id).subscribe(
      data => {
        this.DataList_Contractor_Customer = data

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion


  //#region User First
  Selected_FirstUser:string='0'
  DataList_FirstUser:Array<General_Interface>=[]
  Read_FirstUser(){
    this.DeviceBehfa_Service.GetFirstUserRepair(this.Token).subscribe(
      data=>{
        this.DataList_FirstUser=data
      }
    )
  }

  //#endregion


  OnSet_DeviceBehfaRepair() {
    this.OnBack_DeviceBehfaRepairForm.emit(-1);
  }

  onSubmit() {

    if (this.UserDsc.trim().length < 100) {
      this.Alertify_Service.ErrorMessage("Enter a description of at least 100 characters.")
    }
    else if(this.Selected_FirstUser=='0')
    {
      this.Alertify_Service.ErrorMessage("Select the primary reviewer.")
    }
    else {
      this.InProccessing = true
      this.DeviceBehfa_Service.PostRepair(
        this.inner_DeviceBehfa.id,
        this.UploadImageSrc_List,
        this.Selected_FirstUser,
        this.UserDsc,
        this.Data_Seleted_DeviceBehfa_Record.id,
        this.Token).subscribe(
          data => {
            this.InProccessing = false
            this.Alertify_Service.SuccessMessage("Request submitted successfully.")
            this.inner_DeviceBehfa.id = data['id']
            this.OnInitial()
          }, error => {
            localStorage.clear()
            location.reload();
          }
        )
    }

  }

  PostAnswerFirst(id: number) {

    if (this.UserDscFirst.trim().length < 100) {
      this.Alertify_Service.ErrorMessage("Enter an initial-review description of at least 100 characters.")
    }
    else {
      this.InProccessing = true
      this.DeviceBehfa_Service.PostAnswerFirst(
        this.Token,
        this.inner_DeviceBehfa.id,
        this.UserDscFirst,
        id).subscribe(
          data => {
            this.InProccessing = false
            this.Alertify_Service.SuccessMessage("Saved successfully.")
            this.OnInitial()
          }, error => {
            localStorage.clear()
            location.reload();
          }
        )
    }

  }

  PostAnswerSecond(id: number) {

    if (this.UserDscSecond.trim().length==0) {
      this.Alertify_Service.ErrorMessage("Enter the description.")
    }
    else if (this.Selected_Contractor_Customer.id == 0 && id == 1) {
      this.Alertify_Service.ErrorMessage("Select a customer.")
    }
    else {
      this.InProccessing = true
      this.DeviceBehfa_Service.PostAnswerSecond(
        this.Token,
        this.Selected_Contractor_Customer.id,
        this.inner_DeviceBehfa.id,
        this.UserDscSecond,
        id).subscribe(
          data => {
            this.InProccessing = false
            this.Alertify_Service.SuccessMessage("Saved successfully.")
            this.OnInitial()
          }, error => {
            localStorage.clear()
            location.reload();
          }
        )
    }

  }

  PostAnswerThird() {

    if (this.third_dsc.trim().length < 100) {
      this.Alertify_Service.ErrorMessage("Enter a description of at least 200 characters.")
    }
    else if (this.third_device_id == "0") {
      this.Alertify_Service.ErrorMessage("Select the instrument status.")
    }
    else if (this.Selected_Money.id== 0) {
      this.Alertify_Service.ErrorMessage("Select the unit.")
    }
    else {
      this.InProccessing = true
      this.DeviceBehfa_Service.PostAnswerThird(
        this.Token,
        this.third_phone+'',
        Number(this.third_device_id),
        this.inner_DeviceBehfa.id,
        this.Selected_Money.id,
        this.third_price2+'',
        this.third_dsc).subscribe(
          data => {
            this.InProccessing = false
            this.Alertify_Service.SuccessMessage("Saved successfully.")
            this.OnInitial()
          }, error => {
            localStorage.clear()
            location.reload();
          }
        )
    }

  }

  OnInitial() {
    this.DeviceBehfa_Service.GetSingleRepair(this.Token, this.inner_DeviceBehfa.id).subscribe(
      data => {
        this.UploadImageSrc_List = data['file']

        this.canEditMainForm = data['canEditMainForm']
        this.canAnswerFirst = data['canAnswerFirst']
        this.canAnswerSecond = data['canAnswerSecond']
        this.canAnswerThird = data['canAnswerThird']

        this.UserDsc = data['record']['user_dsc']

        this.Data_Seleted_DeviceBehfa_Record.id = data['device']['id']
        this.Data_Seleted_DeviceBehfa_Record.codeBEHFA = data['device']['codeBEHFA']
        this.Data_Seleted_DeviceBehfa_Record.model = data['device']['model']
        this.Data_Seleted_DeviceBehfa_Record.manufacturer = data['device']['manufacturer']
        this.Data_Seleted_DeviceBehfa_Record.description = data['device']['description']

        this.UserDscFirst = data['record']['first_dsc']
        this.UserUserNameFirst = data['record']['first_username']
        this.UserDateTimeFirst = data['record']['first_date']
        this.first_Answer = data['record']['first_answer']


        this.UserDscSecond = data['record']['second_dsc']
        this.UserUserNameSecond = data['record']['second_username']
        this.UserDateTimeSecond = data['record']['second_date']
        this.second_answer = data['record']['second_answer']


        this.third_dsc = data['record']['third_dsc']
        this.third_phone = data['record']['third_phone']
        this.third_price = data['record']['third_price']

        this.Selected_Contractor.id = data['contrator']['id']
        this.Selected_Contractor.title = data['contrator']['title']

        this.Selected_Contractor_Customer.title = data['customer']['title']


        this.Selected_Money.id = data['money']['id']
        this.Selected_Money.title = data['money']['title']

        this.ReadData_Contractor()

      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

}
